import { put, select, take } from 'redux-saga/effects';

import { CHECK_MOBILE_SETTING } from './actions';
import { SAVE_IS_MOBILE } from 'reducers/compModels';


function* mobile() {
  while (true) {
    yield take(CHECK_MOBILE_SETTING);

    const { isMobile } = yield select(state => {
      return {
        isMobile: state.reader.isMobile
      };
    });

    if (isMobile && window.innerWidth > 480) {
      yield put({ type: SAVE_IS_MOBILE });
    }

    if (!isMobile && window.innerWidth <= 480) {
      yield put({ type: SAVE_IS_MOBILE });
    }
  }
}


export default mobile;
